import { device, checkScreenOrientation, delParam, parseUrl, getPageUrlParams, base64, md5, getOsVersion, getParamNbc, getMoreOfferQueryParams } from './util'
import App from "../class/App";

/**
 * 拼接click_url
 * @param {object} defaultCampaign
 * @param {object} clickPosition 点击坐标对象
 * @param {object} bridgeContext v3接口上下文
 */
export function setClickUrl(defaultCampaign, clickPosition, bridgeContext) {
  const scale = clickPosition.scale;
  const cdnate_cfg = bridgeContext.appSetting?bridgeContext.appSetting.cdnate_cfg:"";
  // let device_width = '';
  // let device_height = '';
  // if (bridgeContext.device) { // 安卓sdk 9.7.0 及以下不返回device字段
  //   device_width = bridgeContext.device.screen_width ? bridgeContext.device.screen_width : "";
  //   device_height = bridgeContext.device.screen_height ? bridgeContext.device.screen_height : "";
  //   if (device().isiOS) {
  //     device_width = (bridgeContext.device.device_width ? bridgeContext.device.device_width : 0) * scale;
  //     device_height = (bridgeContext.device.device_height ? bridgeContext.device.device_height : 0) * scale;
  //   }
  // }
  // 宏替换业务，click_url ，2021.5.11 新增 ad_tracking.click下宏替换
  // 获取campaign.click_url
  let click_url = defaultCampaign.click_url;
  // 获取campaign.ad_tracking.click
  let adTrackingClick = defaultCampaign.ad_tracking?defaultCampaign.ad_tracking.click:"";
  // 构造与appsetting下发相同的格式
  // 举例：
  // "c.gdt.qq.com": {
  //    "x": ["__DOWN_X__", "__UP_X__"],
  //    "y": ["__DOWN_Y__", "__UP_Y__"],
  //    "width": ["__WIDTH__"],
  //    "height": ["__HEIGHT__"]
  // },
  // __WIDTH__  : 实际广告位的宽，单位为像素
  // __HEIGHT__ ：实际广告位的高，单位为像素
  // __DOWN_X__ ：用户手指按下去的横坐标
  // __DOWN_Y__ ：用户手指按下去的纵坐标
  // __UP_Y__ ：用户手指离开设备屏幕时的横坐标，与__DOWN_X__ 值一样
  // __UP_Y__ ：用户手指离开设备屏幕时的纵坐标，与__DOWN_Y__值一样
  let tar = {
    x: parseInt(clickPosition.x),
    y: parseInt(clickPosition.y),
    width: parseInt(document.body.clientWidth)* scale, // 这里原来为设备宽高，其他模版为全屏模版，设备宽高即广告位宽高，由于banner不是全屏模版，需改为实际宽高
    height: parseInt(document.body.clientHeight)* scale,
    sld: clickPosition.isAutoClick ? 2 : 0
  }
  // 宏替换封装
  function macroReplace(url){
    let rel = /.+:\/\/(.*?)\//;
    let relhost = rel.exec(url)
    // 获取不带协议的域名
    let host = relhost ? relhost[1] : '';
    // 如果配置中域名存在
    if (cdnate_cfg && cdnate_cfg[host]) {
      // 获取 appsetting 下对应域名的 宏数据
      let item = cdnate_cfg[host];
      // 遍历宏数据对象（上面举例的对象）
      for (let k in item) {
        // 获取每个key 对应的宏数组
        let arr = item[k]
        // 遍历宏数组，将宏数组中每个宏替换为当前key对应的值
        for (let i = 0; i < arr.length; i++) {
          url = url.replace(new RegExp(arr[i], 'g'), tar[k])
        }
      }
    }
    // 返回替换后的url
    return url
  }
  defaultCampaign.click_url = macroReplace(click_url)
  console.log('宏替换后click_url: ', defaultCampaign.click_url)
  if(adTrackingClick){
    adTrackingClick = adTrackingClick.map((url)=>{
      return macroReplace(url)
    })
    defaultCampaign.ad_tracking.click = adTrackingClick
    console.log('宏替换后ad_tracking.click: ', defaultCampaign.ad_tracking.click)
  }
  return defaultCampaign
}

/**
 * 拼接notice_url，点击坐标宏上报拼接
 * @param {object} defaultCampaign,campaign对象
 * @param {object} clickPosition 点击坐标对象 ，包括x,y,scale
 * @param {boolean} autoClick 是否为自动storekit
 */
export function setNoticeUrl(defaultCampaign, clickPosition, startPoint, autoClick, ctabanner) {
  let notice_url = defaultCampaign.notice_url;
  // 以下为所有点击坐标宏需要上报的参数，先删除，再重新拼接
  notice_url = delParam(defaultCampaign.notice_url, 'click_x');
  notice_url = delParam(notice_url, 'click_y');
  notice_url = delParam(notice_url, 'click_ori');
  notice_url = delParam(notice_url, 'click_senario');
  notice_url = delParam(notice_url, 'click_scale');
  notice_url = delParam(notice_url, 'webviewStartX');
  notice_url = delParam(notice_url, 'webviewStartY');
  notice_url = delParam(notice_url, 'webviewWidth');
  notice_url = delParam(notice_url, 'webviewHeight');
  notice_url = delParam(notice_url, 'endscreen_type');
  notice_url += `&webviewWidth=${document.body.clientWidth * clickPosition.scale}&webviewHeight=${document.body.clientHeight * clickPosition.scale}`;
  notice_url += `&webviewStartX=${startPoint.startX ? Number(startPoint.startX) : 0}&webviewStartY=${startPoint.startY ? Number(startPoint.startY) : 0}`;
  if (!autoClick) {//只有在不是自动storekit的情况下，拼接横纵坐标和方向
    let ori = checkScreenOrientation() === 'portrait' ? 1 : 2;
    notice_url += `&click_x=${parseInt(clickPosition.x)}&click_y=${parseInt(clickPosition.y)}&click_ori=${ori}`;
  }
  if (device().isAndroid) {//安卓额外拼接scale
    notice_url += '&click_scale=' + clickPosition.scale;
  }
  let isAutoClick = autoClick ? 2 : 0;//这个变量为了传click_senario
  notice_url += `&click_senario=${isAutoClick}`;//click_senario=0 表示不是自动点击，2 是自动点击，0 表示误点击
  // ctabanner的点击要拼接endscreen_type=3
  if (ctabanner) {
    notice_url += "&endscreen_type=3"
  }
  // install 逻辑目前是放在了 tpl1 中执行，所以大模板初始化的环境变量（是否扣回调，是否超时）在 tpl1 中目前是获取不到的，
  // notice_url 上报的 to cbt 逻辑不正确的问题，这个问题按目前的实现来看不好修，
  // 所以目前是针对 notice_url 这个字段不再额外拼接 to cbt 等 6 个参数
  // notice_url = appendBizParam(notice_url);

  defaultCampaign.notice_url = notice_url
  return defaultCampaign
}

/**
 * 初始化 more offer 请求 appwall 接口时的入参
 * @param initData
 * @param campaign
 * @param params 自定义请求参数
 * @returns {{only_impression: number, offset: number, tnum: number, exclude_ids: [], os_version: number, sign: (string), language: (string|string), api_version: string, platform: number, country_code: string, http_req: number, package_name: *, ping_mode: number, app_version_name: string, category: number, app_id: number, unit_id: number, ad_num: number}}
 */
export function generateMofV3RequestUrl(initData = {}, campaign = {},params = {},templateType,{ctxUrl = location.href} = {}) {
  // 初始化兜底参数
//     获取system_id和backup_id
  let nbc = getParamNbc({device: initData.device, sdkInfo: initData.sdk_info});
  let moreQuery = getMoreOfferQueryParams(initData);
  let mofParam = Object.assign({
    ad_num: 20,
    api_version: '1.3',
    app_version_name: '3.9.0',
    category: 0, // 不再限制单子类型, 后面交给算法选, 当前固定传 0 不限制 - 流量所需要的offer的分类 1: game 2: application 3: brand 4: e-commerce 0: 不限
    country_code: 'CN',
    http_req: 2,
    language: navigator.language || 'zh-Hans-CN',
    offset: 0,
    only_impression: 1,
    package_name: getPageUrlParams('mof_pkg', ctxUrl),
    ping_mode: 1,
    platform: device().isAndroid ? 1 : device().isiOS ? 2 : 0, // 1 安卓, 2 iOS, 0 other
    app_id: device().isAndroid ? 92762 : 92763, // 安卓 appkey: 936dcbdd57fe235fd7cf61c2e93da3c4
    sign: device().isAndroid ? '4c3814fdba4acd6f3b092b3df43f8d9a' : '193df46b1b8f8a3622bf97afd49948ab',
    tnum: 20,
    unit_id: device().isAndroid ? 117361 : 51309,
    os_version: 11.0,
    e: [], // exclude_ids
    // 固定值 - 用来区分请求来自 endcard 还是 playable
    // 1 表示 endcard
    // 2 表示 playable
    // 3 表示新架构下的播放模板, 如（v11 始终固定为 3）
    // 4 表示 m banner more offer
    // 5 表示 v11 优化方案下的新 Endcard
    h5_type: 5,
    parent_exchange:"",
  }, nbc, moreQuery, params)

  // 设备信息
  let initDevice = initData.device
  // 主 offer 信息
  let mainCampaign = campaign
  let objNoticeUrl = parseUrl(mainCampaign && mainCampaign.notice_url)
  let mainCampaignRequestId = objNoticeUrl && objNoticeUrl.params && objNoticeUrl.params.k
  // 当前页面 url 入参
  let urlParams = parseUrl(location.href).params

  // 获取初始化拆分 unit_id 开关，mof_uid/mof_testuid
  mofParam.mof_uid = getPageUrlParams('mof_uid', ctxUrl)
  mofParam.mof_testuid = getPageUrlParams('mof_testuid', ctxUrl)
  // 主 offer 的 campaign id
  mofParam.offer_id = mainCampaign.id
  // 主 offer 的 request id (notice_url.k)
  mofParam.r_id = mainCampaignRequestId

  // idfa(iOS) 和 gaid、android_id、imei、android_id(Android) 等设备唯一标示, 用于后续的流量归因
  if (initDevice) {
    if (initDevice.idfa)
      mofParam.idfa = initDevice.idfa

    if (initDevice.idfv) mofParam.idfv = initDevice.idfv
    if (initDevice.oaid) mofParam.oaid = initDevice.oaid

    // google_ad_id 需要以 base64 方式传输, 并且使用自有码表
    // 传输字段不能直接使用 gaid(明文), 需要通过 gaid2 字段发送 base64 编码后的数据
    if (initDevice.google_ad_id) {
      try {
        mofParam.gaid2 = base64().encode64(initDevice.google_ad_id)
      } catch (e) {
        console.error('base64 error: ', e)
      }
    }
    if (initDevice.device_imei)
      mofParam.imei = initDevice.device_imei

    if (initDevice.android_id)
      mofParam.android_id = initDevice.android_id

    // 屏幕方向，0-未知，1-竖屏，2-横屏
    if (initDevice.orientation === 'landscape') {
      mofParam.orientation = '2'
    } else if (initDevice.orientation === 'portrait') {
      mofParam.orientation = '1'
    } else {
      mofParam.orientation = '0'
    }

    // 操作系统版本号, 由于安卓的 device.system_version 返回的并非真正的 Android 系统版本, 所以这里统一从 ua 中解析获取
    if (getOsVersion(initDevice.device_ua))
      mofParam.os_version = getOsVersion(initDevice.device_ua)

    // 机型
    if (initDevice.device) {
      mofParam.model = initDevice.device || ''
    }
    // 网络类型
    if (initDevice.network_type) {
      mofParam.network_type = initDevice.network_type
    }
    // 由于无法获取到 brand, adn 这边可以根据 ua 解析到 brand 所以这里额外传递了 useragent 给服务端
    mofParam.useragent = encodeURIComponent(initDevice.device_ua || navigator.userAgent)
    // 透传 re_domain 字段
    if(initDevice.re_domain){
      mofParam.re_domain = initDevice.re_domain;
    }
  }

  // 国别码
  if (initData.appSetting && initData.appSetting.country_code) {
    mofParam.country_code = initData.appSetting.country_code
  }
  // SDK 版本
  // 特殊兼容: 由于安卓某些版本可能返回 sdk_info: "MAL_9.6.0,3.0.1" 的形式, 所以需要对这种不规则的版本格式进行兼容
  // banner模版 sdk_info 在 appSetting 下
  if (device().isAndroid) {
    mofParam.sdk_version = (initData.sdk_info && initData.sdk_info.split(',')[0]) || (initData.appSetting && initData.appSetting.sdk_info && initData.appSetting.sdk_info.split(',')[0]) || getPageUrlParams('sdk_version', ctxUrl);
  } else {
    mofParam.sdk_version = initData.sdk_info || initData.appSetting && initData.appSetting.sdk_info || getPageUrlParams('sdk_version', ctxUrl);
  }
  // 从 SDK 获取 - 需要排除的 offer id, 当前需要排除的始终为主 offer id // exclude_ids
  mofParam.e.push(mainCampaign && mainCampaign.id)
  mofParam.e = encodeURIComponent(JSON.stringify(mofParam.e))
  console.log('mainCampaign', mainCampaign)

  // 透传oneId
  const oneId = mainCampaign.req_ext_data.oneId
  if (oneId) {
    mofParam.oneId = encodeURIComponent(JSON.stringify(oneId))
  }
  // 服务端透传 - 移动国家号码，由3位数字组成，唯一地识别移动用户所属的国家
  mofParam.mcc = urlParams.mcc || ''
  // 服务端透传 - MNC:移动网号，由两位数字组成，用于识别移动用户所归属的移动网
  mofParam.mnc = urlParams.mnc || ''
  // 固定值 - 用来标识该请求为一次 H5 的 more offer 请求: 0 和不传表示普通的appwall请求, 1 表示more offer请求
  mofParam.mof = 1
  // 固定值 - 用于标记mof类型，"猜你喜欢" 为 1，"关闭场景广告" 为 2，服务端目前主要用于记录，暂不进行逻辑处理
  mofParam.mof_type = 1
  // 算法对于 more offer 需要的上下文信息
  mofParam.mof_data = encodeURIComponent(JSON.stringify({
    crt_cid: mainCampaign && mainCampaign.id || '', // 当前展示的主广告的 offerid
    crt_rid: mainCampaignRequestId || '', // 和当前 campaign 对应的 request_id
    rv_tid: urlParams && urlParams.rv_tid || '', // 服务端透传 - 视频播放模板 id
    ec_id: urlParams && urlParams.ec_id || '', // 服务端透传 - endcard 模板 id
    tplgp: urlParams && urlParams.tplgp || '', // 服务端透传 - 模板组合 id
    v_fmd5: urlParams && urlParams.v_fmd5 || '', // 服务端透传 - 视频 file_md5 值
    i_fmd5: urlParams && urlParams.i_fmd5 || '', // 服务端透传 - 图片 file_md5 值
    h5_t: 1, // 1 表示 endcard, 2 表示playable
    mof_t: 1, // 1 标识 more offer, 2 表示 "关闭广告"
  }))

  // 如果存在 mof_uid, 或 mof_testuid,则在请求 appwall 时额外增加以下新的上报参数, 用于提供给 adn 和 算法,mof_testuid优先级高于mof_uid
  if (mofParam.mof_uid || mofParam.mof_testuid) {
    // 服务端透传 - 页面入参中存在 mof_uid 或 mof_testuid 时, 就不再使用写死的 51309 作为 appwall unit id 了，
    mofParam.unit_id = mofParam.mof_testuid || mofParam.mof_uid
    // 固定值 - 用来区分请求来自 endcard 还是 playable，1表示endcard；2表示playable；3表示新架构下的播放模板, 如（v11 始终固定为 3）
    // mofParam.h5_type = 3
    // 从 SDK 获取 - 表示所属的 rv 广告位 id，android banner unit_id 位置为 unitSetting.unitId
    mofParam.parent_unit = initData.unit_id || initData.unitSetting.unitId || getPageUrlParams('unit_id', ctxUrl) || ''
    // mof_uid 开启时, 需要从 SDK 获取真实的 app_id sign 进行上报
    if (initDevice) {
      mofParam.app_id = initDevice.appId || mofParam.app_id
      mofParam.sign = md5(mofParam.app_id + initDevice.appkey || '')
    }
    // console.log('mof_uid or mof_testuid actived, [unitid app_id sign] refreshed, [h5_type parent_unit] added.')
  } else {
    // 如果当前没有开启拆分 unit, 也没有 mof_testuid, 则在传参中增加当前 AD 主 offer 的 unit id,android banner unit_id 位置为 unitSetting.unitId
    mofParam.uc_parent_unit = initData.unit_id || initData.unitSetting.unitId|| ''
  }

  // 如果开启了批量上报, 则需要额外增加以下参数
  if (urlParams.n_imp == 1) {
    // 固定值 - 用来标识该请求为一次 H5 的 more offer 请求: 0 和不传表示普通的appwall请求, 1 表示more offer请求
    mofParam.mof = 1
    // 固定值 - 用来标识当前 more offer 的版本号, 每次版本更新+1, 当前版本为 2
    mofParam.mof_ver = 4
  }

  return mofParam
}

/**
 * 生成H5Setting
 * @param {Object} 关键参数 {...App.initData, adShowTime: App.adShowTime}
 */
export const getAdStatus = (function () {
  let H5Setting = null
  function _initSetting({ campaignList, rewardSetting, appSetting, adShowTime }) {
    let campaign = campaignList[0];
    let expired = false;
    let loadTimeStamp = campaign.timestamp;
    let adType = campaign.ad_type ? Number(campaign.ad_type) : Number(campaign.adType);
    let plct = 0;
    if (campaign.plct) {
      plct = campaign.plct
    } else if ((adType === 94 || adType === 287) && rewardSetting && rewardSetting.plct) {
      plct = rewardSetting.plct
    } else if (appSetting && appSetting.plct) {
      plct = appSetting.plct
    } else {
      plct = 3600
    }
    plct = plct * 1000;
    // 超过plct
    if (adShowTime - loadTimeStamp > plct) {
      expired = true;
    } else {
      expired = false
    }
    return {
      expired
    }
  }
  return function ({ campaignList, rewardSetting, appSetting, adShowTime }) {
    return H5Setting ? H5Setting : _initSetting({ campaignList, rewardSetting, appSetting, adShowTime })
  }
})()

// 判断当前 endcard 在当前平台上加载时，是否安全无问题
// 原因：部分 3d playable 素材在安卓上加载时有概率卡死
export function isEndcardTemplateSafeForLoad (campaignList) {
  return new Promise(((resolve, reject) => {
    let has3dPlayable;
    campaignList.forEach(campaign => {
      if (parseUrl(campaign.endcard_url).params['dpwgl'] === '1') {
        has3dPlayable = true
      }
    })
    if (device().isAndroid && has3dPlayable) {
      let msg = `android webview 目前不支持加载 3d playable 素材: ${location.href}`;
      console.error(msg)
      reject({
        msg,
        data: {}
      })
    } else {
      resolve()
    }
  }))
}

/**
 * 检查传入的 url 是否是 "普通 endcard"
 * @param endcard_url 要检查的 url
 * @returns {boolean} 是返回 true，否则返回 false
 */
export function isStaticEC(endcard_url) {
  let isSTEC = false
  if (endcard_url) {
    let objEndcardUrl = parseUrl(endcard_url);
    isSTEC = objEndcardUrl && objEndcardUrl.params && objEndcardUrl.params['static_ec'] === '1'
    console.log('endcard_url static_ec valid.', objEndcardUrl)
  } else {
    console.warn('endcard_url static_ec invalid.', endcard_url)
  }
  return isSTEC
}

/**
 *@author WangPing
 *@date 2021-03-08
 *@desc 解析dns域名
 *@param {}
 *@return {}
 */
export function parseDns() {
  let mtgDns = decodeURIComponent(getPageUrlParams('mtgDns'));
  if(mtgDns.indexOf("mtgDns")>-1){
    console.log("走兜底域名")
    mtgDns = "https://mtg-h5.rayjump.com"
  }
  return mtgDns
}
